import { Fragment } from "react";

import type { IContract } from "@framework/types";
import { emptyStateString } from "@dzambalaorg/draft-js-utils";
import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { useFetchData } from "@dzambalaorg/react-hooks";

import { ContractContent, CraftContactPanel } from "../../../../components";
import { TemplateList } from "../template-list";

export const Contract = () => {
  const {
    data: selected = {
      title: "",
      description: emptyStateString,
    } as IContract,
    isLoading,
  } = useFetchData<IContract>(`/contracts`); // We don't use the id because it's embedded in the hook request.

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "marketplace", "marketplace.contract"]} data={[{}, {}, selected]} />

      <PageHeader message="pages.marketplace.contract.title" data={selected}>
        <CraftContactPanel contract={selected} />
      </PageHeader>

      <ContractContent contract={selected} />

      <TemplateList embedded />
    </Fragment>
  );
};
